<template>
    <div>
        <div class="content-header row">
            <div class="content-header-left col-md-6 col-12 mb-2">
                <h3 class="content-header-title mb-0">Settings</h3>
                <div class="row breadcrumbs-top">
                    <div class="breadcrumb-wrapper col-12">
                        <ol class="breadcrumb">
                            <li class="breadcrumb-item"><a href="/">Home</a>
                            </li>
                            <li class="breadcrumb-item active"> Ride Settings
                            </li>
                        </ol>
                    </div>
                </div>
            </div>
        </div>

        <div class="content-body">
            <section class="card">
                <div class="card-header">
                    <h4 class="card-title">Ride Settings</h4>
                </div>
                <div class="card-body">
                    <form @submit.prevent="updateRideSetting">
                        <div class="row">
                            <div class="col-6 mb-3">
                                <label for="price_per_km" class="form-label">Price Per Km</label>
                                <div class="input-group">
                                    <span class="input-group-text">₦</span>
                                    <input v-model="setting.amount_per_kilometer" id="price_per_km"
                                           class="form-control" type="number">
                                </div>
                            </div>
                            <div class="col-6 mb-3">
                                <label for="price_per_minute" class="form-label">Price per minute</label>
                                <div class="input-group">
                                    <span class="input-group-text">₦</span>
                                    <input v-model="setting.price_per_minute" id="price_per_minute"
                                           class="form-control" type="number">
                                </div>
                            </div>
                            <div class="col-6 mb-3">
                                <label for="keru_fee_percentage" class="form-label">Keru Fee Percentage</label>
                                <div class="input-group">
                                    <span class="input-group-text">%</span>
                                    <input v-model="setting.keru_fee_percentage"
                                           id="keru_fee_percentage" class="form-control" type="number">
                                </div>
                            </div>
                            <div class="col-6 mb-3">
                                <label for="lasg_levy" class="form-label">LASG levy</label>
                                <div class="input-group">
                                    <span class="input-group-text">₦</span>
                                    <input v-model="setting.lasg_levy" id="lasg_levy"
                                           class="form-control" type="number">
                                </div>
                            </div>
                            <div class="col-6 mb-3">
                                <label for="max_hours_online_daily" class="form-label">Driver's Max Hours Online
                                    Daily</label>
                                <div class="input-group">
                                    <input v-model="setting.max_hours_online_daily" id="max_hours_online_daily"
                                           class="form-control" type="number" max="24">
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-4 col-xs-12">
                                <button class="btn btn-primary" v-if="!saving">update</button>
                            </div>
                        </div>
                    </form>
                </div>
            </section>
        </div>
    </div>
</template>

<script>
import Layout from '@/Shared/Layout';
import {VueEditor} from "vue2-editor";
import ValidationErrors from "../../Shared/ValidationErrors";

export default {
    metaInfo: {title: 'Ride Setting'},
    name: 'RideSettingCreate',
    props: ['settingsData'],
    components: {
        VueEditor,
        ValidationErrors
    },
    layout: Layout,
    data() {
        return {
            saving: false,
            setting: [],
        }
    },
    methods: {
        async updateRideSetting() {
            this.saving = true;
            this.$inertia.put(route('admin.settings.ride.update'), {...this.setting}, {
                preserveScroll: true,
                onSuccess: () => this.saving = false,
                onError: () => {
                    this.saving = false;
                }
            });
        }
    },
    created() {
        let data = Object.keys(this.settingsData);
        if (data.length) {
            this.setting.price_per_minute = this.settingsData.price_per_minute;
            this.setting.amount_per_kilometer = this.settingsData.amount_per_kilometer;
            this.setting.lasg_levy = this.settingsData.lasg_levy;
            this.setting.max_hours_online_daily = this.settingsData.max_hours_online_daily;
            this.setting.keru_fee_percentage = this.settingsData.keru_fee_percentage;
        }
    },
}
</script>
